import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'
import { formatDateForComparison } from '../utils/dateUtils'

export interface DailySleepData {
  date: string
  duration: number
  quality: number
  sleepScore: number
  bedtime?: string
}

export const useSleepData = (userId?: string, startDate?: Date, endDate?: Date) => {
  return useQuery<DailySleepData[]>({
    queryKey: ['sleep-data', userId, startDate?.toISOString(), endDate?.toISOString()],
    enabled: Boolean(userId && startDate && endDate),
    queryFn: async () => {
      const { data, error } = await supabase
        .from('sleep_summaries')
        .select('calendar_date, duration_seconds, start_time_seconds')
        .eq('user_id', userId!)
        .gte('calendar_date', formatDateForComparison(startDate!))
        .lte('calendar_date', formatDateForComparison(endDate!))

      if (error) {
        throw error
      }

      return (data || []).map((item) => {
        let bedtime: string | undefined
        if (item.start_time_seconds) {
          const bedtimeDate = new Date(item.start_time_seconds * 1000)
          bedtime = bedtimeDate.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          })
        }

        return {
          date: item.calendar_date,
          duration: item.duration_seconds / 3600,
          quality: 0.8,
          sleepScore: 75,
          bedtime,
        }
      })
    },
  })
}
